export interface IUser {
  _id?: string;
  avatar?: string;
  name: string;
  email: string;
  password: string;
  phoneNumber?: string;
  social?: ISocial[];
  role?: ERole;
  address?: {
    city?: string;
    ward?: string;
    street?: string;
  };
  isTax?: boolean;
  accessToken?: string;
  refreshToken?: string;
  isDelete?: boolean;
  addressInfo: IAddress;
  createdAt?: string;
  updatedAt?: string;
}

export interface IAddress {
  address: string;
  city: string;
  ward: string;
}

export interface ISocial {
  icon: string;
  link: string;
  name: string;
}

export enum ERole {
  SUPPER = 'SUPPER',
  ADMIN = 'ADMIN',
  USER = 'USER',
}
